(function() {
  $(document).ready(function()
  {
    var tier_next=2;
    var backup_of_tier_next=2;
    var tier_prev=5;
    var backup_of_tier_prev=5;

    $(document).on("swell:setup",function() {
      Swell.Campaign.initializeCampaigns(".we_list", SwellConfig.Campaign.opts);
      SwellConfig.Campaign.appendLoggedInClass();
      SwellConfig.Campaign.append_referal_campaign();
      
      //refer
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
      SwellConfig.Referral.authenticated();
      SwellConfig.Referral.populateReferrals();
      if(!spapi.authenticated)
      {
        $(".swell-referral").append('<div class="redeem-holder"> <h3>How do I redeem<br> my reward balance? </h3> <div class="redeem-content"> <p>Now, the fun part! Simply redeem any rewards credit you\'ve earned directly at checkout.</p> </div> </div>');
      }
      if($(".thank-you-popup").length > 0 && window.location.href.indexOf("checkouts") == -1)
      {
        $(".thank-you-popup").css("display","block");
      }

      //tiers
      SwellConfig.Tier.initializeDummyTier();
      SwellConfig.Tier.initializeCustomTierProperties();
      SwellConfig.Tier.initializeTiers(".swell-tier-table");
      // SwellConfig.Tier.setCustomerTierStatus();

      $(".loader").remove();
    });

    $(document).on("swell:referral:success", function() {
      swellAPI.refreshCustomerDetails(function() 
      {
        $(".swell-referral-tbody").html("");
        SwellConfig.Referral.populateReferrals();
      });
    });

    $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
      if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED") {
        $(".refer-customer-error").remove();
        $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
      }

      if(textStatus && textStatus === "Please enter a valid email address") {
        $(".refer-customer-error").remove();
        $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
      }
    });

    var x = window.matchMedia("(max-width: 767px)")
    set_tiers_mobile_screen(x) // Call listener function at run time
    x.addListener(set_tiers_mobile_screen) // Attach listener function on state changes

    $('body').on('click','.thank-you-popup-inner .sr_popup .swell-referral-back-link',function()
    {
      $('.thank-you-popup').css("display","none");
    });

    $('body').on('click','.table_arrow_right',function()
    {
      tier_next++;
      var tabledata='.td';
      var tabledata_prev='.td';
      if(tier_next == 5)
      {
        backup_of_tier_next = tier_next;
        tier_next = 2;
        tabledata = tabledata + tier_next;
        tabledata_prev = tabledata_prev + (backup_of_tier_next-1);
        $(tabledata_prev).css("display","none");
        $(tabledata).css("display","table-cell");
        tier_prev = 5;
      }
      else
      {
        tabledata = tabledata + tier_next;
        if(tier_next == 2)
        {
          tabledata_prev = tabledata_prev + (tier_prev);
          $(tabledata_prev).css("display","none");
        }
        else
        {
          tabledata_prev = tabledata_prev + (tier_next-1);
          $(tabledata_prev).css("display","none");
        }
        $(tabledata).css("display","table-cell");
        tier_prev = tier_next;
      }
    });

    $('body').on('click','.table_arrow_left',function()
    {
      tier_prev--;
      var tabledata='.td';
      var tabledata_next='.td';
      if(tier_prev == 1)
      {
        backup_of_tier_prev = tier_prev;
        tier_prev = 4;
        tabledata = tabledata + tier_prev;
        tabledata_next = tabledata_next + (backup_of_tier_prev+1);
        $(tabledata_next).css("display","none");
        $(tabledata).css("display","table-cell");
        tier_next = 1;
      }
      else
      {
        tabledata = tabledata + tier_prev;
        if(tier_prev == 4)
        {
          tabledata_next = tabledata_next + (tier_next);
          $(tabledata_next).css("display","none");
        }
        else
        {
          tabledata_next = tabledata_next + (tier_prev+1);
          $(tabledata_next).css("display","none");
        }
        $(tabledata).css("display","table-cell");
        tier_next = tier_prev;
      }
    });

  });
}).call(this);


(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: '<li class="swell-campaign"> <div class="swell-campaign-content" data-display-mode="modal" data-campaign-id="<%= campaign.id %>"> <div class="swell-campaign-icon"> <span class="swell-campaign-icon-content"> <i class="<%= campaign.icon %>"><span class="path1"></span><span class="path2"></span></i> </span> </div> <div class="swell-campaign-side"> <div class="swell-campaign-value"> <span class="swell-campaign-value-content"><%= campaign.reward_text %></span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content"><%= campaign.title %></span> </div> </div> </div> </li>',
      }
    },
    append_referal_campaign: function()
    {
      // $(".we_list .swell-campaign:nth-child(5)").after('<li class="custom-referral-campaign swell-campaign"> <div class="swell-campaign-content dummy-campaign" data-display-mode="modal" data-campaign-id=""> <div class="swell-campaign-side"> <div class="swell-campaign-value"> <span class="swell-campaign-value-content">Refer friends and earn points</span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content">Refer new friends and get $10.</span> </div> <a href="/pages/refer" class="btn_ text-uppercase">Start referring here</a> </div> </div> </li>');
      $(".we_list .swell-campaign:nth-child(5)").after('<li class="custom-referral-campaign swell-campaign"> <div class="swell-campaign-content dummy-campaign" data-display-mode="modal" data-campaign-id=""> <div class="swell-campaign-side"> <div class="swell-campaign-value"> <span class="swell-campaign-value-content">Refer friends and earn $10 in points</span> </div>  <a href="/pages/refer" class="btn_ text-uppercase">Start referring here</a> </div> </div> </li>');
    },
    appendLoggedInClass:function()
    {
      if(spapi.authenticated)
      {
        $(".swell-campaign-content").addClass("LoggedInCampaigns");
      }
    }
  };
}).call(this);

//Refer 
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
       localization: {
         referralSidebarDetailsAction: "Refer a Friend",
         referralSidebarDetailsReward: "",

         referralRegisterHeading: "Give $10, Get $10",
         referralRegisterFormDetails: "Please submit your email below to get started.",
         referralRegisterFormEmail: "Submit your email to get started....",
         referralRegisterFormSubmit: "",
         referralRegisterDetails: "Give your friends $10 off their first order of $50+ and get $10 for each successful referral.",

         referralReferHeading: "Give $10, Get $10",
         referralReferFormEmails: "Your friends’ emails (separated by commas)",
         referralReferFormSubmit: "",
         referralReferFormDetails: "Now, enter your friends' emails below.",
         referralReferFormEmailsDetails: "",
         referralReferDetails: "Give your friends $10 off their first order of $50+ and get $10 for each successful referral.",

         referralReferMediaDetails: "You can also share your link with the buttons below.",

         referralShareFacebook: "Share",
         referralShareTwitter: "Twitt",
         referralShareCopy: "Copy Link",

         referralFacebookIcon: "swell-icon-rewardsfacebook1",
         referralTwitterIcon: "swell-icon-rewardsTwitter",
         referralLinkIcon: "swell-icon-rewardscopy-link",

         referralThanksHeading: "Thanks for Referring!",
         referralThanksDetails: "Remind your friends to check their emails.",

         referralCopyHeading: "",
         referralCopyButton: "COPY LINK",
         referralCopyDetails: "Copy and share link with your friends"
      },
       templates: {
         referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <p class="swell-referral-details"><%= localization.referralRegisterDetails %></p> <div class="swell-referral-border"></div> <div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> <span class="input_btn_holder"><input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"></span> </li> </ul> </div> </form> </div> </div>',
         referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"><%= localization.referralReferDetails %></p> <div class="swell-referral-border"></div> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> <span class="input_btn_holder"><input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"></span> </li> </ul> </div> <span class="swell-referral-form-field-details"></span> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareFacebook %> </div> </li><li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-rewardssms" aria-hidden="true"></i>&nbsp;SMS </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-rewardsmessage" aria-hidden="true"></i>&nbsp;Message</div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareCopy %> </div> </li> </ul></div> </div>'
       }
    },
    authenticated: function()
    {
      if(spapi.authenticated)
      {
        $(".swell-referral-sidebar").css("display","block");
      }
    },
    populateReferrals: function(){
      if (spapi.authenticated) {
        var referral_receipts = spapi.customer.referral_receipts;
        referral_receipts.forEach(function(referral_receipt) {
          var email = referral_receipt.email;
          var completed_at = referral_receipt.completed_at;
          if (completed_at) {
            status = "Purchased (" + spapi.activeReferralCampaign.reward_text + " earned)";
          } else {
            status = 'Invited';
          }
          $(".swell-referral-tbody").append("<tr><td>" + email + "</td><td>" + status + "</td></tr>");
        });
      }
    }
  };

}).call(this);


//tiers

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Tier = {
    getCustomerTierId: function() {
      var customer_tier, intro_tier, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier) {
        return customer_tier.id;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].id;
        } else {
          return null;
        }
      }
    },
    getCustomerTierRank: function() {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id) {
        rank = $.grep(tiers, function(e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        } else {
          return null;
        }
      }
    },
    getTierByRank: function(rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.rank === rank;
      })[0];
    },
    setupCustomerTierStatus: function() {
      var $tierStatusRow, $tierValueRow, col, columnLength, customer_tier_id, customer_tier_rank, data_id, dollar_difference, encouragement, index, k, l, next_tier, ref, ref1;
      customer_tier_id = SwellConfig.Tier.getCustomerTierId();
      customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
      next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
      $(".swell-tier-table").addClass("swell-tier-status");
      $(".swell-tier-table thead").prepend("<tr class=\"swell-tier-status-row\">\n  <td scope=\"row\"></td>\n <td scope=\"col\" class='td2'></td>\n<td scope=\"col\" class='td3'></td>\n<td scope=\"col\" class='td4'></td>\n</tr>");
      $("[data-tier-id=\"" + customer_tier_id + "\"]").addClass("swell-tier-active");
      // var custom_current_status_index = $("[data-tier-id=\"" + customer_tier_id + "\"]");
      // $tierStatusRow.find("td:eq("+index + ")").html("<span class='current'>Current</span>");
      // alert(custom_current_status_index);
      var index_custom = $(".swell-tier-active").index();

      columnLength = $(".swell-tier-table tbody tr:eq(0)").children().length;
      $tierStatusRow = $(".swell-tier-status-row");
      $tierValueRow = $(".swell-tier-values");
      
      $tierStatusRow.find("td:eq("+ index_custom+")").html("<span class='current'>Current</span>");
      
      encouragement = "";
      dollar_difference = "";
      for (col = k = 1, ref = columnLength - 1; 1 <= ref ? k <= ref : k >= ref; col = 1 <= ref ? ++k : --k) {
        data_id = $(".swell-tier-table tbody tr:first td:eq(" + (col - 1) + ")").first().data("tierId");
        if (data_id === customer_tier_id) {
          for (index = l = 1, ref1 = col; 1 <= ref1 ? l <= ref1 : l >= ref1; index = 1 <= ref1 ? ++l : --l) {
            $tierValueRow.find("td:eq(" + index + ")").addClass("completed");
            // $tierStatusRow.find("td:eq(" + index + ")").addClass("completed");
          }
        }
      }
    },
    initializeDummyTier: function() {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: -1,
        rank: 0,
        name: "Tiny",
        points: "Annual Spend:<br>$0 - 99",
        one_point_multiplier: "1x",
        exclusive_products: "<i class=\"swell-icon-rewardscheck\"></i>",
        exclusive_promotion: "<i class=\"swell-icon-rewardscheck\"></i>",
        free_shipping: "",
        free_gifts: "",
        swellrequiredAmountSpent: "$0",
        swellrequiredAmountSpentCents: 0,
        swellrequiredPointsEarned: 0,
        swellrequiredPurchasesMade: 0,
        swellrequiredReferralsCompleted: 0
      });
    },
    initializeCustomTierProperties: function() {
      spapi.activeVipTiers[1].points = "Annual Spend:<br>$100 - 199";
      spapi.activeVipTiers[1].one_point_multiplier = "1.5x";
      spapi.activeVipTiers[1].exclusive_products = "<i class=\"swell-icon-rewardscheck\"></i>";
      spapi.activeVipTiers[1].exclusive_promotion = "<i class=\"swell-icon-rewardscheck\"></i>";
      spapi.activeVipTiers[1].free_shipping = "<i class=\"swell-icon-rewardscheck\"></i>";
      spapi.activeVipTiers[1].free_gifts = "";

      spapi.activeVipTiers[2].points = "Annual Spend:<br>$200+";
      spapi.activeVipTiers[2].one_point_multiplier = "2x";
      spapi.activeVipTiers[2].exclusive_products = "<i class=\"swell-icon-rewardscheck\"></i>";
      spapi.activeVipTiers[2].exclusive_promotion = "<i class=\"swell-icon-rewardscheck\"></i>";
      spapi.activeVipTiers[2].free_shipping = "<i class=\"swell-icon-rewardscheck\"></i>";
      return spapi.activeVipTiers[2].free_gifts = "<i class=\"swell-icon-rewardscheck\"></i>";
    },
    initializeTiers: function(containerSelector) {
      var i, j, key, properties, property, ref, ref1, tiers;
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      properties = {
        header: {
          points: {
            className: "swell-tier-values",
            title: ""
          },
          name: {
            className: "swell-tier-names",
            title: "Benefits"
          }
        },
        body: {
          one_point_multiplier: {
            title: "Points multiplier"
          },
          exclusive_products: {
            title: "Exclusive access to new items"
          },
          exclusive_promotion: {
            title: "Exclusive promotion"
          },
          free_shipping: {
            title: "Free shipping"
          },
          free_gifts: {
            title: "Free gifts"
          }
        }
      };
      $(containerSelector).append("<thead></thead>");
      $(containerSelector).append("<tbody></tbody>");
      j = 0;
      ref = properties.header;
      for (key in ref) {
        var tdclassno=1;
        var tdclass="td";
        var tdclass_append=null;
        property = ref[key];
        $(containerSelector).find("thead").append("<tr class=\"" + property.className + "\">\n  <td scope=\"row\">" + property.title + "</td>\n</tr>");
        tiers.forEach(function(tier) {
          tdclassno++;
          tdclass_append = tdclass + tdclassno;
          return $(containerSelector).find("thead tr:eq(" + j + ")").append("<td scope=\"col\" data-tier-id=\"" + tier.id + "\" class=\"" + tdclass_append + "\">" + tier[key] + "</td>");
        });
        j++;
      }
      var name1 = $(".swell-tier-names .td2").text();
      $(".swell-tier-names .td2").text('Stage 1: '+name1);
      
      var name2 = $(".swell-tier-names .td3").text();
      $(".swell-tier-names .td3").text('Stage 2: '+name2);

      var name3 = $(".swell-tier-names .td4").text();
      $(".swell-tier-names .td4").text('Stage 3: '+name3);

      i = 0;
      ref1 = properties.body;
      for (key in ref1) {
        var tdclassno=1;
        var tdclass="td";
        var tdclass_append=null;
        property = ref1[key];
        $(containerSelector).find("tbody").append("<tr>\n  <td scope=\"row\">" + property.title + "</td>\n</tr>");
        tiers.forEach(function(tier) {
          tdclassno++;
          tdclass_append = tdclass + tdclassno;
          return $(containerSelector).find("tbody tr:eq(" + i + ")").append("<td data-tier-id=\"" + tier.id + "\" class=\"" + tdclass_append + "\" >" + tier[key] + "</td>");
        });
        i++;
      }
      if (spapi.authenticated) {
        return SwellConfig.Tier.setupCustomerTierStatus();
      }
    }
  };

}).call(this);

function set_tiers_mobile_screen(x) {
  if (x.matches) 
  { 
    $(".td2").css("display","table-cell"); 
    $(".td3").css("display","none"); 
    $(".td4").css("display","none"); 
  } 
  else
  {
    $(".td2").css("display","table-cell");
    $(".td3").css("display","table-cell");
    $(".td4").css("display","table-cell");
  }
}